(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["full-width-carousel"] && !Shopify.designMode) return;
  try {
    
var cycleFullWidthCarousel;
jQuery(document).ready(function () {

cycleFullWidthCarousel = function() {
var $active = jQuery('.full-width-carousel .active');
var $next = ($active.next().length > 0) ? $active.next() : $('.full-width-carousel .full-width-carousel__image:first');
$next.css('z-index', 2);//move the next image up the pile
$active.fadeOut(1500, function () {//fade out the top image
$active.css('z-index', 1).show().removeClass('active');
$next.css('z-index', 3).addClass('active');
});
}
setInterval(cycleFullWidthCarousel, 5000);
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-with-image-block"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    const images = document.querySelectorAll('.full-width-text-block__images__image img');
    const textBlocks = document.querySelectorAll('.full-width-text-block__highlight-text');
    let lastIndex = 0; // To keep track of the last hovered index

    // Set default active text block and image
    if (textBlocks.length > 0) {
        textBlocks[0].style.display = 'block';
        textBlocks[0].style.opacity = '1';
        images[0].style.opacity = '1';
    }

    images.forEach((img, index) => {
        img.addEventListener('mouseover', () => {
            lastIndex = index; // Update lastIndex to current hover
            textBlocks.forEach((textBlock, textIndex) => {
                if (textIndex === index) {
                    textBlock.style.display = 'block';
                    setTimeout(() => {
                        textBlock.style.opacity = '1';
                    }, 10); // Small delay to ensure display is set before opacity transition
                } else {
                    textBlock.style.opacity = '0';
                    setTimeout(() => {
                        textBlock.style.display = 'none';
                    }, 300); // Matches the transition duration for opacity
                }
            });
            images.forEach((otherImg, otherIndex) => {
                otherImg.style.opacity = otherIndex === index ? '1' : '0.3';
            });
        });

        img.addEventListener('mouseout', () => {
            images.forEach((otherImg, otherIndex) => {
                otherImg.style.opacity = otherIndex === lastIndex ? '1' : '0.3';
            });
        });
    });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list-slider"] && !Shopify.designMode) return;
  try {
    
var cycleFullWidthCarousel;
jQuery(document).ready(function () {


jQuery('.product-list-slider').flickity({
  wrapAround: true,
  pageDots: false,
  cellAlign: 'left',
  imagesLoaded: true,
  fade: this.image_transition == 'fade' ? true : false,
  arrowShape: arrowShape,
  groupCells: '100%', // Default for desktop

  // Responsive settings
  responsive: {
    768: { // Applies for screens below 768px (mobile)
      groupCells: 2, // Show 2 slides per view
      cellAlign: 'left', // Ensure proper alignment
      contain: true // Prevents excessive blank space
    }
  }
});

cycleFullWidthCarousel = function() {
var $active = jQuery('.full-width-carousel .active');
var $next = ($active.next().length > 0) ? $active.next() : $('.full-width-carousel .full-width-carousel__image:first');
$next.css('z-index', 2);//move the next image up the pile
$active.fadeOut(1500, function () {//fade out the top image
$active.css('z-index', 1).show().removeClass('active');
$next.css('z-index', 3).addClass('active');
});
}
setInterval(cycleFullWidthCarousel, 5000);
})

  } catch(e) { console.error(e); }
})();
})();
